module.exports = ["de","en","es","fr","it","nl","pl","ru","sv"]


//////////////////
// WEBPACK FOOTER
// ./src/assets/langs_wiki_technology_norm.json
// module id = GcA0
// module chunks = 1